var _style, _rect, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _defs9, _defs10, _defs11, _defs12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInvestigationicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 99.4 74.9",
    style: {
      enableBackground: "new 0 0 99.4 74.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{enable-background:new    ;}\n\t.st2{clip-path:url(#SVGID_00000178204235252412969230000017596884945744127148_);}\n\t.st3{clip-path:url(#SVGID_00000142869178245587733540000009907523711614927009_);}\n\t.st4{clip-path:url(#SVGID_00000154399869845296224980000017191646880168845723_);fill:#2795E3;}\n\t.st5{clip-path:url(#SVGID_00000133514918608351660760000012323379672144729788_);}\n\t.st6{clip-path:url(#SVGID_00000040544765714990779700000002568485758018582415_);fill:#2795E3;}\n\t.st7{clip-path:url(#SVGID_00000113346953156622867480000011871193617466271415_);enable-background:new    ;}\n\t.st8{clip-path:url(#SVGID_00000044162046954901356560000010099957429037911454_);}\n\t.st9{clip-path:url(#SVGID_00000000201316137230642420000001492402076205984143_);fill:#2795E3;}\n\t.st10{clip-path:url(#SVGID_00000074415563715255279180000007683546007461512103_);}\n\t.st11{clip-path:url(#SVGID_00000054974171455768141170000011885400488778159802_);fill:#2795E3;}\n\t.st12{clip-path:url(#SVGID_00000019643069594816690840000010117439539150775726_);}\n\t.st13{clip-path:url(#SVGID_00000044900586752190747200000005792907404119332009_);fill:#2795E3;}\n")), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 105,
    height: 79,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGoAAABQCAYAAADxwOBcAAAACXBIWXMAAAsSAAALEgHS3X78AAAL VklEQVR4nO1dW3LjRgyEZCdX2o/cKYfJnfKRK2UtKR8xtK1WN4AhacepBFVTpCly2DON55CyIv6X f4Wc/mkAv/7xu8Tw27dfbp+N5SvLpxHlCFmV/yqBH05UQdD03paYzyJtq5Idie/DiDKDO9G2wnEb 7EfEsRMyJMWdU+LYg/NQoobknIrPUhQxbnuXPRMxtPzJfDEGiWkV62FEiYE6gk7QOgw3aEHbQwhb sPyOMEfQId5gN1FDgrjxcTzfkcItxP5dJhOwqFxqy6Jwub+XsO4iqhlo7p/jmagznec0lNvVHA+x jQg9CRutf+ICnQLtVqxNRA0JSkJOtK+Iq4i6in1HWDsJC9g7T6DwIu7KI/D5TzhZlokaDNQRc4am CENRlnSlfUda0H4lHTEdYYiXt5VHYIwtWUtEGZIqC6oan4+iSMpBXkITV1mYEmUlrDzK+iP8vPHk K2/QegFF1pkPLAgPCNsLtVfRftrQuA+8x9SlRtQk4RjceLpjfB33V5KvMtFXM5AnoYvVhCirUcCV ZU0t6vJ+zeW9uWuvYgippTwO5wW2WpTCfwJM1/d+GeP+ZGKBJNYepXFuMhg0k4RkXWj/Ys5VLlBZ EuNxms/zwJgZv3PfDuMDVnSBY4sy4HJgyvTZNUxdQDXIC1x7oWsv8YxPWVbiVhbzEo9kVW60U/JT PCtJxKPVpWWxIj1ZV2tRhTV1MckR5TSWB+Os6rLQONPCcaiYxGR17u5mjuMYIh6tR1m/y17vVrVi UROSXmNOFPaV/ecAc3CoddkYQ5U0XOB6NRbGo0jqXBz3q/ZzjFfY5z6q+9REgTWxX1exCUnCfXaJ eB32ySDRdahYcY1HXHw9WuSZBq7S8K6+c4UqWtWNrlNkMc5UJOnyUlYtKrcYm1wazkRVQRr758yJ rShjEVpJqY3xOBHKmjp3rIppZU0ujuUWyUqSWBEVfk9UYU0qw1N1knJ5SmM7otB6rnAu41LCE6w8 Q5fddasL3B+6cxxX0LmKJFQm7H9c8KJGMFnKolSccnWUilnKHbmYWMVDpyiOnIqkSZlQlQbuXmV2 mQYzdX3Kn7tEAve7moQt4yb2U/PYMjpLqmoUR5jqx9VBnFIn5lR+NoKTON/d+yleSaLI7bE1ufjU peIOIN+rqtCZNBSl/Zwid9qtrInJuYQnniecjymyFB5MpiJiZlHKmpAI5XqcW1OglDZNRKW5FVF4 TofBxaVLeLeG1hR03I2twvBw/RNRQ2vqLAoLSGc5fAxFpbxqANjHS2wnymFQ/eEW8bALx4ZjwWt4 y1Z1lweiivcHVHzizG9Si+AkTC1HaSVncOkSGRsugGK9wuNSJOVWWRYrAWLAzJTrI+c92rlwrk8N QmVgihRnHWqyO5AqEaiwuoyS6xe8rrq3wuAwMSm8ZcyT8d/lTlTzuhROBE/KKkkVaL6W99UxhbNq W4XvV2FW2z33bpOJKgGYBOSJJSnNUlpbWRVjZsXC4hKxjV2POEeNTcWdaf+lvEaM3m3ryHFAHEn8 mbqucjN4vXMtCj9+rva5D76+Grf6rIrRat+KsqhKM/hzdzPnFvA6XklWfUyJctY2cXccszhRYQtl fAGfdQW+u3frLaZ11ES6oK8EF1yr/tgFqvN4Hz9Xfac4b5JZZG6rPiLqZTHuN0JjtnO49wnvxEXx +Z0r4GNTorqXMycJCUriVCTlhLM1VplwNXcOy/3YKlGdFuSEucEpQBV5HUEdlqkidTG6WgVBQpks tqpOkex4V4nCDtyNVDaE1/Hn1X2Um1DnrDYWVC4Xj/FzRRRbknJ9iDu37gXSB5kQ1VkPPkHliaji 25S4CakK24QsLgkUbhwbkxR0TeXu1Nypvh763fLOROdiOlF1yESQSOc++diULNR+dtkuEXBa77Jl xlW90KK8VUR4otiFlZ0I4JNaq6tlbuZ4hRdxKGJwkvg6JkvhUxM/qckclqlrlkQhSWzqVadce5zF MZaKCJx4lzGpfqaZqXJ/SBZ/7hROiVIW94oYL/BKos4R5dc9lP+sOlQF4vTx+8pnVWHJ+Bm70mZ8 vO4mEMfX1UwqNlVv8kqyJm/KshaXAS80Qa7o44FMxU06HsPHGHxtZVHpOV7ib7JexDlB57OgW1TP rpxVtW4vok4mJjFCZTmVxh8lqImIdaXI5Dh1jh8vbKIoN8j7EY/9Mca01u7dixB/30FEROv+yk5C kzR58+io5t5nV+Oo4kYXP9y4Wbp7VMlERDzz0aXnnFDggNkfq4q8cn97hN2csih3XW6ZAOU2T3A8 z6/uwZPuyFlyewnkSd4fe7CV4Ht0P0XEz9Dy7/xMvU93FFEuCXiLiO/Q/oSWx97i+RuLKcptT76J gnFpyzt/T8nZ+BuH7yeW6SIJp+Gcoh/Z2GK7uKTEJRfK5bm56NJ1tpxu0TgifAjastanZDqZRwgm OfiYZEpWFbzVcpjKEBVJnTvM/q27q74VfxRREXoQq5o+vc8kJu293ySJqLJA7IOt56nf7v9MbH3M 0X3GGvcRyUTX38Rl86Rx4oTH2Z3jygsnGpN7te4OZUqU8qeVn8eGFnCEqHhR+f6xVgucrGgqm+X7 sDu2svI/m2QyQcD5bxUYVeVdBeKtoghwy0HuMcJEKhfulo+65aRdirr6mCO3alJUzYCBOWUr4Iok h2NphVpgmxCEco1HyzuEpIh9Dw55QnKNLPdP79sUtt4V8Jw5qXurZRq3ElBJlQxxjcVuPcdflSeb PMuWB4dMUhZ0uaCZA0HAEY/ErMQtZxF4b9W4hsm+uF/EhPuVJeH3kYP6nyxIL5O1mkxU1vQWfd2U A0CSqiyJ752Tj4S80dYRNo1ZLj65dUYcS/f45cMsKjvFtDVjD7o4BPgG1zip6h6XXSorVmQhYXsS i0kykceqwvtTkwmMDwkM/3PKWzyCcsCQ+CrjrGISE/SdtmxZk1Vwh7mKV0yCsyLV77JsKXixVuB/ c8Pawy7z5f34Gc5zQVZldUiQa46kcvmGZDKxLgXfTYqSadaHkoEzQVX/5UsF7yQsAy+TjJbkSEKy lEUpwo6o43h8TsEOF+t+RNWsYobS8O+mVZrPk8rujRs+ylD9K5c3taYwn/P4cZ/7VUq6S7qVCb5R FdgVUYq4jrC3ps9OEdy/hnsiqFBG/FtlnTgHPB+rSjGSLSsTKVd5libVpfdYj5yojyouKUtDkjkB YVzdODuCspDHOqpaEZnct5TSosyioaunXNxwT1udlU2sh/tRLq8kaYM1OVetygFH0mYLa10fDchp mwK/OvkrxExdXuuCDGFOGZWFV7F2pTQoZRSjBoOpXNVk0tni/hTHVOybxKRJbMJx4fh4LZHv15UF KyVBKeMY9du3X270XV+2NK6dcB8H/ho/4pOLURiknda+xeMkqnj4gHP4/KdSQB4vjll5FkXQJsKm WV9ELLuJzg2y1Tircu5uor2rJPHYutUQHpOLlZ9nUSk5YLCu1C4EUdUvCR7fTK2yPrQa3rIl5bVT V4fiYjGuwtxCr4xjwqHwfU6MUjJIMlbiFsYuZUkqFd8bjyqpkohqCUtZ+SFxatdbSEXcQh+eWhjx w5LU62QoVdalYtHWeMTiXDvGm7QwXqNUeC05X+WHvqpHBN1KcwoOnMm50jm7rcj8VzXG6h6xI1mM 85CYudn1sSzUW67u6tLeyqocji3CfTr3t1I/7cV0/JL8xt9nUsIuRSULe13dXQa/5NM9ynD4DsF6 mEUVINSEq0SjyvKqOumQXw0dlh7sGbo1vieStsqHPORKKayr2k9hV8rHIuL43+JdwOxE4b7LVrwf SlTEIT+YHPEJBKHsxGxxfZnf4a3kqJ8gj/j6v2jNcgTeTyOKZToJX/G34RX2r4jzf/kH5C/h63FT EguNgQAAAABJRU5ErkJggg==",
    transform: "matrix(1 0 0 1 -5.6348 -4.1452)"
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -5.6,
    y: -4.1,
    className: "st0",
    width: 105,
    height: 79
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 7.3,
    y: 8.4,
    width: 85,
    height: 59
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000072964869517969304050000002050127420340059043_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000072964869517969304050000002050127420340059043_)"
    }
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000086655584113571570730000013347443699999076786_",
    d: "M13.1,36.6h38.8c0,3.9-0.2,7.9,0.1,11.8 c0.2,2.9-0.7,4.8-3.1,6.5c-4.6,3.2-8.8,6.9-13.2,10.3c-2,1.6-4.2,1.6-6.1,0.1c-5-3.9-10-7.8-15-11.8c-0.6-0.5-1.3-1.4-1.3-2.2 C13.1,46.5,13.1,41.7,13.1,36.6"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000080891369314826280880000003130753793235965865_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000086655584113571570730000013347443699999076786_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000080891369314826280880000003130753793235965865_)"
    }
  }, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000050660780230326705310000006136646179665930430_",
    x: -2.7,
    y: -1.6,
    width: 105,
    height: 78
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000160190048079824425620000003743695544758189501_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000050660780230326705310000006136646179665930430_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 12.1,
    y: 35.6,
    style: {
      clipPath: "url(#SVGID_00000160190048079824425620000003743695544758189501_)",
      fill: "#2795E3"
    },
    width: 41.1,
    height: 32.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000072964869517969304050000002050127420340059043_)"
    }
  }, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000047777723929186624880000004608890336251570561_",
    d: "M82.3,56.3c0,1.5,0.1,2.9,0,4.4 c-0.2,3.1-2.5,5.5-5.2,5.5c-2.9,0-5.1-2.3-5.1-5.5c-0.1-3-0.1-6,0-9.1c0.1-3.1,2.3-5.3,5-5.3c2.8-0.1,5.1,2.2,5.3,5.4 C82.4,53.2,82.3,54.8,82.3,56.3"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000070097805177074517740000003589485623905697952_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000047777723929186624880000004608890336251570561_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000070097805177074517740000003589485623905697952_)"
    }
  }, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000168104707673094857560000012666298723710136218_",
    x: -2.7,
    y: -1.6,
    width: 105,
    height: 78
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000163034512195680769370000016883480038003734415_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000168104707673094857560000012666298723710136218_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 70.8,
    y: 45.3,
    style: {
      clipPath: "url(#SVGID_00000163034512195680769370000016883480038003734415_)",
      fill: "#2795E3"
    },
    width: 12.5,
    height: 22
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000072964869517969304050000002050127420340059043_)"
    }
  }, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000039114463790286017690000017148593125445811127_",
    x: 7.3,
    y: 8.4,
    width: 85,
    height: 58
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000179632588266648468150000016133340349818754726_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000039114463790286017690000017148593125445811127_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000179632588266648468150000016133340349818754726_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000083810449600728076090000016838852570724483720_",
    x: 6.3,
    y: 7.4,
    width: 87,
    height: 38
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000103260354980632099670000009277906133312956546_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000083810449600728076090000016838852570724483720_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000103260354980632099670000009277906133312956546_)"
    }
  }, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000077305094765805852080000017781561241795464887_",
    x: 75.5,
    y: 42.2,
    width: 3.3,
    height: 3.1
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000017512852422818376670000004602693969926005391_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000077305094765805852080000017781561241795464887_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 74.5,
    y: 41.2,
    style: {
      clipPath: "url(#SVGID_00000017512852422818376670000004602693969926005391_)",
      fill: "#2795E3"
    },
    width: 5.3,
    height: 5.1
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000103260354980632099670000009277906133312956546_)"
    }
  }, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000181067526181255823560000012057039701310536895_",
    d: "M55.6,31.9c-1.8,0.1-2.2-0.6-2.4-2.3 c-1.2-9.2-7.8-16.8-16.3-19.1c-0.9-0.2-1.7-0.8-2.5-1.3c-1.5-1-3-1.1-4.5,0.1c-0.6,0.5-1.2,1-1.9,1.2 c-7.5,2.1-12.4,6.9-15.1,14c-0.9,2.3-1.3,4.7-2,7.1c-3.9,0.5-3.9,0.5-3.7,2h49.5c0.2-0.2,0.4-0.5,0.5-0.7 C56.7,32.6,56.2,31.8,55.6,31.9z M24.3,31.7h-1.9c-1.9-1.9,2.5-14.3,6.4-18.2c0.5,0.3,1,0.7,1.6,1.1 C26.3,19.6,24.5,25.3,24.3,31.7z M40.8,31.7c-0.3-6.2-1.9-11.9-6.2-16.9c0.6-0.5,1.1-0.8,1.7-1.3c4.8,5.2,6.4,11.4,6.8,18.2 H40.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000136370986363377758590000008523592219396419260_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000181067526181255823560000012057039701310536895_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000136370986363377758590000008523592219396419260_)"
    }
  }, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000005960249086751949960000017448242364265365377_",
    x: 7.3,
    y: 8.4,
    width: 85,
    height: 58
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000113340484029407434030000017218779754041671611_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000005960249086751949960000017448242364265365377_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 6.3,
    y: 7.4,
    style: {
      clipPath: "url(#SVGID_00000113340484029407434030000017218779754041671611_)",
      fill: "#2795E3"
    },
    width: 52,
    height: 27.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000103260354980632099670000009277906133312956546_)"
    }
  }, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000015336529179832174570000015343091122090512263_",
    d: "M77.1,10.6c-8.4-0.1-15.4,6.8-15.4,15.1 c0,8.5,6.8,15.5,15.3,15.5c8.4,0,15.2-6.8,15.2-15.2C92.3,17.4,85.6,10.6,77.1,10.6 M77,37.4c-6.4,0-11.5-5.1-11.6-11.5 c0-6.5,5.2-11.8,11.6-11.7c6.2,0,11.6,5.3,11.7,11.6C88.9,32,83.4,37.5,77,37.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000084501129086604117020000010263290521759230877_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000015336529179832174570000015343091122090512263_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000084501129086604117020000010263290521759230877_)"
    }
  }, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000096768826964502287230000018376221845483753910_",
    x: 7.3,
    y: 8.4,
    width: 85,
    height: 58
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000087389484795639350370000013178801349596551823_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000096768826964502287230000018376221845483753910_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 60.7,
    y: 9.5,
    style: {
      clipPath: "url(#SVGID_00000087389484795639350370000013178801349596551823_)",
      fill: "#2795E3"
    },
    width: 32.6,
    height: 32.7
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestigationicon);
export default __webpack_public_path__ + "static/media/investigationicon.c88f225e0d94f1e2ed0cd8a4e49706ed.svg";
export { ForwardRef as ReactComponent };